module.exports = __webpack_public_path__ + "static/media/search.5ce4b9ae.svg";